<template>
    <div class="full-width" v-loading="loading">
        <div class="operation-box">
            <div class="btn-group" v-if="null != memberObj && viewTag == 'update'">
                <a
                    class="a-text"
                    :href="eshopopeeUrl"
                    v-if="eshopopeeTag"
                    target="eshopopee"
                >
                    <el-button
                        plain
                        type="primary"
                        tkey="修改信息"
                    >
                        {{i18n.tkey("lang_modify_information")}}
                    </el-button>

                    <el-button
                        plain
                        :color="'#8E44AD'"
                        tkey="添加用戶"
                    >
                        {{i18n.tkey("lang_add_user")}}
                    </el-button>

<!--                    <el-button-->
<!--                        plain-->
<!--                        v-if="memberObj.addinfo6 != -1"-->
<!--                        tkey="設置管理員"-->
<!--                    >-->
<!--                        {{i18n.tkey("lang_set_admin_text")}}-->
<!--                    </el-button>-->

<!--                    <el-button-->
<!--                        type="danger"-->
<!--                        v-if="memberObj.addinfo6 == -1"-->
<!--                        tkey="取消管理員"-->
<!--                    >-->
<!--                        {{i18n.tkey("lang_cancel_admin")}}-->
<!--                    </el-button>-->
                </a>

                <a
                    class="a-text"
                    href="javacript: void(0)"
                    v-if="!eshopopeeTag"
                >
                    <el-button
                        plain
                        :color="'#8E44AD'"
                        @click="changeViewTag('add')"
                        tkey="添加用戶"
                    >
                        {{i18n.tkey("lang_add_user")}}
                    </el-button>

<!--                    <el-button-->
<!--                        plain-->
<!--                        v-if="memberObj.addinfo6 != -1"-->
<!--                        @click="setStaffAdmin(-1)"-->
<!--                        tkey="設置管理員"-->
<!--                    >-->
<!--                        {{i18n.tkey("lang_set_admin_text")}}-->
<!--                    </el-button>-->

<!--                    <el-button-->
<!--                        type="danger"-->
<!--                        v-if="memberObj.addinfo6 == -1"-->
<!--                        @click="setStaffAdmin(0)"-->
<!--                        tkey="取消管理員"-->
<!--                    >-->
<!--                        {{i18n.tkey("lang_cancel_admin")}}-->
<!--                    </el-button>-->
                </a>


                <el-button
                    plain
                    v-if="memberObj.addinfo9 != -1 && false"
                    @click="update3dShopman"
                    tkey="設置3D商城店員"
                >
                    {{i18n.tkey("lang_set_three_shopman")}}
                </el-button>
            </div>

            <div class="btn-group" v-if="viewTag != 'update'">
                <el-button
                    plain
                    :color="'#8E44AD'"
                    v-if="viewTag == 'add'"
                    @click="changeViewTag('invite')"
                    tkey="邀請用戶"
                >
                    {{i18n.tkey("lang_invite_user_text")}}
                </el-button>

                <el-button
                    plain
                    :color="'#8E44AD'"
                    v-if="viewTag == 'invite'"
                    @click="changeViewTag('add')"
                    tkey="添加用戶"
                >
                    {{i18n.tkey("lang_add_user")}}
                </el-button>

<!--                <el-button plain :color="'#32c5d2'" tkey="添加上限">{{i18n.tkey("lang_add_limit_num")}}</el-button>-->
            </div>
        </div>

        <insertStaff v-if="viewTag == 'add'" />
        <inviteStaff v-if="viewTag == 'invite'" />
        <editStaff
            v-if="null != memberObj && viewTag == 'update'"
            :member="memberObj"
            @save-complete="saveCallback"
        />
    </div>
</template>

<script setup>
    import {ref, toRef, getCurrentInstance, onMounted, watch, inject, computed} from 'vue'
    import insertStaff from "@/components/shopopee/company/insertStaff"
    import editStaff from "@/components/shopopee/company/editStaff"
    import inviteStaff from "@/components/shopopee/company/inviteStaff"
    import userApi from "@/request/userApi";
    import companyApi from "@/request/companyApi";
    import myUtil from "@/util/util";
    import {useUserinfo} from "@/stores/userinfo";

    const props = defineProps(["editLogin"])
    const emits = defineEmits(["save-complete"])

    const memberObj = ref(null)
    const viewTag = ref("update")

    const loading = ref(false)

    const i18n = inject("i18n")
    const userInfoRef = toRef(useUserinfo())

    const eshopopeeUrl = computed(() => {
        let url = "javascript: void(0)"

        if (null !== userInfoRef.value.acccompanycode){
            url = myUtil.generateEshopopeeManagerJumpUrl(userInfoRef.value.acccompanycode, userInfoRef.value.login, userInfoRef.value.password, "HRMember.asp?shopForm=shopopee")
        }

        return url
    })

    const eshopopeeTag = computed(() => {
        return null !== userInfoRef.value.acccompanycode
    })

    watch(() => props.editLogin, (newValue, oldValue) => {
        if (null != newValue){
            querySimpleMember()
        }
    });

    function querySimpleMember() {
        loading.value = true

        const request = userApi.querySimpleMember
        const params = request.getParams()

        params.login = props.editLogin

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                memberObj.value = res.detail
                changeViewTag("update")
            }
        })
    }

    function setStaffAdmin(tag){
        const request = companyApi.updateStaffAdmin
        const params = request.getParams()

        params.companycode = memberObj.value.companycode
        params.id = memberObj.value.id
        params.addinfo6 = tag

        request.send(params, (res) => {
            if (res.code == 200){
                memberObj.value.addinfo6 = tag
            }else{
                myUtil.alertError(res.msg)
            }
        })
    }

    function update3dShopman() {
        const request = userApi.update3dShop
        const params = request.getParams()

        params.id = memberObj.value.id
        params.companycode = memberObj.value.companycode

        request.send(params, (res) => {
            if (res.code == 200){
                memberObj.value.addinfo9 = -1
            }
        })
    }

    function changeViewTag(tag){
        viewTag.value = tag
    }

    function saveCallback(){
        emits("save-complete")
    }

    onMounted(() => {
        querySimpleMember()
    })

</script>

<style scoped>
    .full-width {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        padding-left: 2px;
        padding-right: 2px;
        box-sizing: border-box;
        padding-top: 30px;
    }

    .operation-box {
        position: relative;
        width: 100%;
    }

    .operation-box .btn-group {
        position: absolute;
        right: 0;
        top: -30px;
    }
</style>